import dayjs from "dayjs";
import strings from '../../Globalization';
import util from '../../util';

export const isValidCriticalParameter = (criticalParameter) => (Array.isArray(criticalParameter) && criticalParameter.length)
	|| (typeof criticalParameter === 'object' && Object.keys(criticalParameter).length);



/**
 * Generates parameters for printing cycle details.
 *
 * @param {Object} options - The options object.
 * @param {Object} options.data - The cycle data object.
 * @param {boolean} options.isChemistry - Indicates if it's a chemistry cycle.
 * @returns {Array} An array of objects containing print details parameters.
 */
export const getPrintDetailsParams = ({ data }) => {
	const dateTimeFormat = util.getDateTimeFormat();
	const printData = data.CycleTape || data.PrinterLines || '';
	const dataProperty = [
		{ Property: 'ReportTitle', Value: strings.CycleLogs || '', LangString: strings.CycleLogs },
		{ Property: 'EquipmentName', Value: data.EquipmentName || '', LangString: strings.EquipmentName },
		{ Property: 'EquipmentType', Value: data.EquipmentTypeName || '', LangString: strings.EquipmentType },
		{ Property: 'SerialNumber', Value: data.SerialNumber || '', LangString: strings.SerialNumber },
		{ Property: 'ModelName', Value: data.ModelName || '', LangString: strings.ModalName },
		{ Property: 'Location', Value: data.LocationName || '', LangString: strings.LocationName },
		{ Property: 'CycleCount', Value: data.CycleCount || '', LangString: strings.CycleCount },
		{
			Property: 'CycleDate',
			Value: dayjs(data.CycleStart).format(dateTimeFormat.datetime) || '',
			LangString: strings.CycleDateTime
		},
		{ Property: 'Parameter', LangString: strings.Parameter },
		{ Property: 'Metric', LangString: strings.Metric },
		{ Property: 'Actual', LangString: strings.Actual },
		{ Property: 'CriticalParamenterTitle', LangString: strings.CriticalParamenterTitle }
	];

	let topSectionDetails = data.TopSection;

	if (Array.isArray(topSectionDetails)) {
		const [items] = topSectionDetails.reduce(
			(acc, curr) => {
				if (Array.isArray(curr)) {
					acc[0] = acc[0].concat(curr);
					acc[1] = acc[1].concat(curr.map((entry) => entry.DataProperty));
				} else if (curr?.DataProperty) {
					acc[0] = acc[0].concat([curr]);
					acc[1] = acc[1].concat(curr.DataProperty);
				}
				return acc;
			},
			[[], []]
		);
		topSectionDetails = items;
	}
	// Flatten groupItems inline with their parent, e.g., [{a}, {b, groupItems:[{x},{y}]}] ➜ [{a}, {b}, {x}, {y}]
	const normalizeData = data.CriticalParameters.flatMap(param => {
		if (param.groupItems && Array.isArray(param.groupItems)) {
			return [param, ...param.groupItems];
		}
		return [param];
	});
	const parameters = (normalizeData || []).map((obj) => ({
		...obj,
		HeaderLabel: obj.isTitle ? obj.HeaderLabel : `${strings[obj.HeaderLabel]}`,
		SubHeaderLabel: obj.SubHeaderLabel || '',
		Index: obj.Index || 0,
		UnitHeader: obj.UnitHeader || '',
		UnitSubHeader: obj.UnitSubHeader || '',
		ColSpan: obj.ColSpan || 0,
		RowSpan: obj.RowSpan || 0,
		Metric: strings[obj.Metric] || obj.Metric || '',
		Actual: strings[obj.Actual] || obj.Actual || '',
		CriticalParameterIcon: obj.CriticalParameterIcon,
		Control: obj.Control || '',
		Independent: obj.Independent || '',
		TabHeader: obj.TabHeader || false,
	}));
	const topSection = topSectionDetails.map(({ label, Value: value, DataProperty, Index, image, HeaderLabel, element, tableView }) => ({
		ClassName: null,
		Image: image || '',
		ImageColor: '',
		Index: Index || -1,
		Label: strings[HeaderLabel] || HeaderLabel || label,
		Type: undefined,
		Value: image || value,
		DataProperty,
		element,
		tableView
	}));

	return [
		{ Name: 'action', Value: 'otherAction' },
		{ Name: 'otherAction', Value: 'printReport' },
		{ Name: 'cycleCount', Value: data.CycleCount },
		{ Name: 'imageUrl', Value: data.CycleImageUrl },
		{ Name: 'cycleName', Value: data.CycleName },
		{ Name: 'cycleTape', Value: printData },
		{ Name: 'topSection', Value: JSON.stringify(topSection) },
		{ Name: 'criticalParameters', Value: JSON.stringify(parameters) },
		{ Name: 'pageInfo', Value: JSON.stringify(dataProperty) },
		{ Name: 'isAdvantage', Value: true },
		{ Name: 'cycleId', Value: data.CycleId }
	];
};